import { RouteHttpVerb } from "@devowl-wp/utils";
const locationRestMigrationDelete = {
    path: "/migration/:migration",
    method: RouteHttpVerb.DELETE
};
export { locationRestMigrationDelete };
